;(function(){
    var $flipper = $('.js-Flipper');
    if ($flipper.length > 0) {
        var min_height = 0;
        var $window    = $flipper.find('.js-Flipper-window');
        var $tiles     = $flipper.find('.js-Flipper-window-tile');
        var $nav       = $('<ul/>', { 'class': 'Flipper-nav  js-Flipper-nav  u-cleanList' });

        $tiles.each(function(i, tile) {
            var $tile = $(tile);
            var class_names = 'Flipper-nav-btn  js-Flipper-nav-btn';
            if (i === 0) {
                class_names += '  is-active';
            }
            var $li = $('<li/>');
            var $btn = $('<button/>', { 'class': class_names, 'text': $tile.data('name') });

            $li.append($btn);
            $nav.append($li);

            if ($tile.height() > min_height) {
                min_height = $tile.height()
            }
        });

        $window.css({ 'height': min_height + 'px' });
        $flipper.append($('<div/>', { 'class': 'Grid-cell  bp2-u-size1of2' }).append($nav));
        var $btns = $nav.find('.js-Flipper-nav-btn');

        $tiles
            .css({ 'position': 'absolute' });
    
        $nav.on('click', '.js-Flipper-nav-btn', function(event) { 
            $('.js-Flipper-nav-btn.is-active')
                .removeClass('is-active');
            $('.js-Flipper-window-tile.is-active')
                .removeClass('is-active')

            $(this)
                .addClass('is-active');
            $tiles
                .eq($btns.index(this))
                .addClass('is-active')
        });

        $(window).on('resize', function(event) {
            $tiles.each(function(_, tile) {
                var $tile = $(tile);
                if ($tile.height() > min_height) {
                    min_height = $tile.height()
                }
            });
            $window.css({ 'height': min_height + 'px' });
        });
    }
}());